import {
  Circle,
  ClipPath,
  Defs,
  Ellipse,
  G,
  LinearGradient,
  Path,
  Polygon,
  Polyline,
  RadialGradient,
  Rect,
  Stop,
  Svg,
  Text,
  Tspan,
} from '@react-pdf/renderer';
import { parse } from 'svg-parser';

import { IChartData } from '../index';
import { IAccountStatementBE } from '@trader/api';
import { defaultActions } from '../constants/defaultState';
import { Line } from 'recharts';

const componentsMap = {
  svg: Svg,
  line: Line,
  polyline: Polyline,
  polygon: Polygon,
  path: Path,
  rect: Rect,
  circle: Circle,
  ellipse: Ellipse,
  text: Text,
  tspan: Tspan,
  g: G,
  stop: Stop,
  defs: Defs,
  clipPath: ClipPath,
  lineargradient: LinearGradient,
  radialgradient: RadialGradient,
};
export const balanceHistoryPositionsActions = [0, 1];
export const getChartData = (
  accountStatement: IAccountStatementBE
): Array<IChartData> => {
  return accountStatement.balanceChart.map((value, index) => ({
    name: index,
    value: value,
  }));
};

export const getCurrentDateTimeGMT = () => {
  const now = new Date();

  return formatDateTime(now, true);
};

export const formatDateTime = (date: Date, hasSeconds: boolean) => {
  const padStart = 2;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(padStart, '0');
  const day = String(date.getDate()).padStart(padStart, '0');
  const hours = String(date.getHours()).padStart(padStart, '0');
  const minutes = String(date.getMinutes()).padStart(padStart, '0');
  const seconds = String(date.getSeconds()).padStart(padStart, '0');

  const dateTime = `${year}.${month}.${day} ${hours}:${minutes}`;

  return hasSeconds ? `${dateTime}:${seconds}` : dateTime;
};

export const formatAccountStatementDatetime = (date: string) => {
  if (date === null) {
    return '';
  }

  const dateObj = new Date(date);

  return formatDateTime(dateObj, true);
};

export const formatDecimal = (amount: number) => {
  const franctionDigits = 2;

  return Number(amount.toFixed(franctionDigits));
};

export const getAccountStatementActionDescription = (id: number) => {
  const action = defaultActions.find(t => t.id === id);

  return action ? action.description : '-';
};

const convertJsonToPdfComponent = (jsonElement, isChart) => {
  if (jsonElement.type === 'element') {
    const { tagName, properties, children } = jsonElement;
    const ChildComponent = componentsMap[tagName];

    if (tagName === 'svg' && isChart) {
      return (
        <Svg width='550' height='150' viewBox='0 0 960 250'>
          {getChildren(children, isChart)}
        </Svg>
      );
    }

    if (tagName === 'line') {
      return (
        <Polyline
          points={`${properties.x1}, ${properties.y1}, ${properties.x2}, ${properties.y2}`}
          {...properties}
        >
          {getChildren(children, isChart)}
        </Polyline>
      );
    }

    if (tagName === 'tspan') {
      return (
        <Tspan
          textAnchor='end'
          x={properties.x}
          dominantBaseline='text-before-edge'
        >
          {getChildren(children, isChart)}
        </Tspan>
      );
    }

    if (
      tagName === 'text' &&
      properties.class === 'recharts-text recharts-label'
    ) {
      return '';
    }

    if (ChildComponent) {
      return (
        <ChildComponent {...properties}>
          {getChildren(children, isChart)}
        </ChildComponent>
      );
    }
  } else if (jsonElement.type === 'text') {
    return jsonElement.value;
  }
  return null;
};

const getChildren = (children, isChart) => {
  return children?.map(child => convertJsonToPdfComponent(child, isChart));
};

export const recursivelyConvertJsonToPdfComponents = (svgContent, isChart) => {
  const svgObject = parse(svgContent);

  return svgObject.children.map(child =>
    convertJsonToPdfComponent(child, isChart)
  );
};
